<template>
  <v-card style="border-radius: 10px">
    <v-card-title>Personal Details</v-card-title>
    <v-card-text>
      <div>Your avatar will be shown on your blog posts as author.</div>
      <ImagePicker
        :url="user.avatarUrl"
        @input="updateAvatar($event)"
        :modes="['UPLOAD']"
        defaultMode="UPLOAD"
        tooltip="Avatar"
        class="mt-2"
      ></ImagePicker>
      <v-form style="width: 350px" class="mt-2">
        <v-text-field
          label="Your Name"
          :value="user.fullName"
          name="oldPassword"
          outlined
          dense
          disabled
          prepend-icon="mdi-account"
        />
        <v-text-field
          label="Your E-mail"
          :value="user.email"
          name="oldPassword"
          outlined
          dense
          disabled
          prepend-icon="mdi-email"
          class="mt-2"
        />
        <v-autocomplete
          label="Your Timezone"
          :items="timezones"
          dense
          outlined
          v-model="user.timezone"
          prepend-icon="mdi-clock"
          @change="updateTimeZone($event)"
        ></v-autocomplete>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";
import ImagePicker from "../components/ImagePicker";

export default {
  computed: {
    ...mapState(["user"]),
  },
  data() {
    return {
      timezones: [],
    };
  },
  components: {
    ImagePicker,
  },
  methods: {
    async updateAvatar($event) {
      this.user.avatarUrl = $event;
      await axios.post("/Console/UpdateAvatar?avatarUrl=" + $event);
    },
    async updateTimeZone($event) {
      this.user.timezone = $event;
      await axios.post("/Console/UpdateTimezone?timezone=" + $event);
    },
  },
  async created() {
    const response = await axios.get("/Console/GetTimeZones");
    this.timezones = response.data.data;
  },
};
</script>